<template>
  <div class="up_invoice_content p_reopen_box">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead/>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>收支</el-breadcrumb-item>
                <el-breadcrumb-item>废票/红冲记录</el-breadcrumb-item>
                <el-breadcrumb-item>申请重开</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_employee_box" v-loading="tableLoading">
            <div class="p_employee_list f_reopen_box">
                <el-form :rules="formRules" ref="statementForm" :model="formQuery" label-width="90px">
                    <el-form-item label="项目:">
                        <span>xxxxx</span>
                    </el-form-item>
                    <el-form-item label="客户名称:">
                        <span>xxxxx</span>
                    </el-form-item>
                    <el-form-item label="法务实体:">
                        <span>XXXXXXXX</span>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 开票抬头 -->
            <div class="p_employee_list mt15">
                <div class="r_edit_title"><div class="line_box"></div>开票抬头</div>
                <div class="com_style pt20 mt15">
                    <el-form :inline="true" :rules="formRules" ref="statementForm" :model="formQuery" label-width="110px">
                        <el-form-item label="开票抬头:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="使用新抬头:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="纳税人识别号:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="营业地址:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="开户行:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="账号:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="电话:">
                            <el-input v-model="formQuery.num" size="small" clearable></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <!-- 选择结算单 -->
            <div class="p_employee_list mt15">
                <div class="r_edit_title"><div class="line_box"></div>选择结算单</div>
                <div class="post_list mt15">
                    <el-table border @selection-change="handleSelectionChange" :data="tableData" style="width:100%">
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <!-- 项目或部门 -->
                        <el-table-column align="center" label="项目" width="90px">
                            <template slot-scope="{row}">
                                <span>{{row.Strmkname}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="归属月" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <span>{{row.Strmkname}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结算单编号" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <span>{{row.Strtoppowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结算单金额" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <span>{{row.Strtoppowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="剩余待开金额" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <span>{{row.Strtoppowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="本次开具金额" min-width="160px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <el-input v-model="row.num" size="small" clearable></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="创建时间" min-width="100px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <span>{{row.Strpowername}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="附件" min-width="100px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <span>{{row.Strpowername}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="add_box flex">
                    <el-select v-model="formQuery.Projectid" placeholder="请选择项目" size="small">
                        <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                    </el-select>
                    <el-button type="primary" class="btn01" size="small" plain @click="addProHandle">+ 可继续添加多项目合并开票</el-button>
                </div>
                <div class="com_style mt15 f_com_box">
                    <div class="flex_box flex">
                        <div class="f_list_box flex">
                            <div class="f_left_box">合计开票金额:</div>
                            <div class="f_right_box">6000.00</div>
                        </div>
                        <div class="f_list_box flex">
                            <div class="f_left_box">结算单:</div>
                            <div class="f_right_box"><i class="el-icon-document f_icon"></i></div>
                        </div>
                        <div class="f_list_box flex">
                            <div class="f_left_box">客户扣款金额:</div>
                            <div class="f_right_box">
                                <el-input v-model="formQuery.num" size="small" clearable></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="com_style pt20 mt15">
                    <el-form :inline="true" :rules="formRules" ref="statementForm" :model="formQuery" label-width="100px">
                        <el-form-item label="开票方式:" prop="num">
                            <div class="f_sel_box flex">
                                <el-select class="f_sel01" v-model="formQuery.num" placeholder="" size="small">
                                    <el-option value="全额(6%)"></el-option>
                                </el-select>
                                <el-select v-model="formQuery.num" placeholder="" size="small">
                                    <el-option value="专票"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item label="开票内容:" prop="num">
                            <el-select v-model="formQuery.num" placeholder="" size="small">
                                <el-option value="服务费"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="业务类型:">
                            <span>业务外包</span>
                        </el-form-item>
                        <el-form-item label="开票金额:">
                            <span>6000.00元</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="com_style pt20 dtl_table">
                    <el-form :inline="true" :rules="formRules" ref="statementForm" :model="formQuery" label-width="100px">
                        <el-form-item label="开票方式:" prop="num">
                            <div class="f_sel_box flex">
                                <el-select class="f_sel01" v-model="formQuery.num" placeholder="" size="small">
                                    <el-option value="全额(6%)"></el-option>
                                </el-select>
                                <el-checkbox v-model="formQuery.checked">合并开票</el-checkbox>
                            </div>
                        </el-form-item>
                        <el-form-item label="业务类型:">
                            <span>业务外包</span>
                        </el-form-item>
                    </el-form>
                    <el-table class="i_list" border :data="invoiceData" style="width:100%">
                        <el-table-column align="center" label="项目" min-width="110px">
                            <template slot-scope="{row}">
                                <span>{{row.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="开票金额" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <el-input v-model="row.num" size="small" clearable></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="票种" min-width="110px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <el-select v-model="row.piao" placeholder="" size="small">
                                    <el-option value="专票"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="开票内容" min-width="160px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row}">
                                <el-select class="f_sel01" v-model="row.content" placeholder="" size="small">
                                    <el-option value="人力资源服务*社保公积金"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="" min-width="100px" fit :show-overflow-tooltip="true">
                            <template slot-scope="{row,$index}">
                                <el-button type="text" v-if="row.type == 'other'" @click="addContentHandle(row)">+ 添加</el-button>
                                <el-button type="text" v-if="row.type == 'dtl'" @click="dltContentHandle($index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="com_style mt15 f_com_box f_foot_box">
                    <div class="f_foot_box flex">
                        <el-checkbox v-model="formQuery.checked">是否寄送</el-checkbox>
                        <div class="flex f_foot">
                            <div class="foot_left_box">邮寄地址</div>
                            <div class="flex">
                                <el-select v-model="formQuery.num" placeholder="" size="small">
                                    <el-option value="xxxx@xxx.com"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="f_foot_box flex mt15">
                        <div class="flex f_open_foot">
                            <div class="foot_left_box o_txt">新地址</div>
                            <div class="flex i_reopen_box">
                                <el-select class="t_sel" v-model="formQuery.num" placeholder="省" size="small">
                                    <el-option value="xxxx@xxx.com"></el-option>
                                </el-select>
                                <el-select class="t_sel" v-model="formQuery.num" placeholder="市" size="small">
                                    <el-option value="xxxx@xxx.com"></el-option>
                                </el-select>
                                <el-select class="t_sel" v-model="formQuery.num" placeholder="区/县" size="small">
                                    <el-option value="xxxx@xxx.com"></el-option>
                                </el-select>
                                <el-input class="t_sel" v-model="formQuery.num" size="small" placeholder="详细地址" clearable></el-input>
                                <el-input class="t_sel" v-model="formQuery.num" size="small" placeholder="收件人" clearable></el-input>
                                <el-input class="t_sel" v-model="formQuery.num" size="small" placeholder="手机号码" clearable></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="f_foot_box flex mt15">
                        <el-checkbox v-model="formQuery.checked">费用结算单盖章一并邮寄</el-checkbox>
                        <div class="flex f_foot">
                            <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="stateFileList">
                                <el-button size="small" type="text">上传结算单</el-button>
                            </el-upload>
                        </div>
                    </div>
                    <div class="f_foot_box flex mt15">
                        <el-checkbox v-model="formQuery.checked">是否自动邮件发送电子/数电发票</el-checkbox>
                        <div class="flex f_foot">
                            <div class="foot_left_box">接收邮箱</div>
                            <el-select v-model="formQuery.num" placeholder="" size="small">
                                <el-option value="xxxx@xxx.com"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p_employee_list mt15">
                <!-- 发票开具申请单 -->
                <!-- <div class="flex aic print_box">
                    <el-button type="text" @click="printClick('printBox','')">打印</el-button>
                </div> -->
                <div class="com_form_box">
                    <div id="printBox">
                        <div class="centerTitle">发票开具申请单</div>
                        <table width="100%" border="0" cellspacing="1" cellpadding="4" class="tabtop form_table" align="center">
                        <tr>
                            <td class="btbg font-center">*合伙人</td>
                            <td></td>
                            <td class="btbg font-center">*业务员</td>
                            <td></td>
                            <td class="btbg font-center">*开票申请人</td>
                            <td colspan="3"></td>
                        </tr>
                        <tr>
                            <td class="btbg font-center">*服务部门</td>
                            <td></td>
                            <td class="btbg font-center">*客服</td>
                            <td></td>
                            <td class="btbg font-center">*法务主体</td>
                            <td colspan="3"></td>
                        </tr>
                        <tr>
                            <td class="btbg font-center">*客户名称</td>
                            <td colspan="4"></td>
                            <td colspan="3">纳税人识别号</td>
                        </tr>
                        <tr>
                            <td class="btbg font-center" rowspan="3">*开票内容</td>
                            <td class="btbg font-center">开票方式</td>
                            <td class="btbg font-center">开票项目</td>
                            <td class="btbg font-center">含税金额(元)</td>
                            <td class="btbg font-center">票据种类</td>
                            <td class="btbg" colspan="3">业务类型:业务外包</td>
                        </tr>
                        <tr rowspan="3">
                            <td class="btbg font-center">全额(6%)</td>
                            <td class="btbg font-center">外包服务费</td>
                            <td class="btbg font-center"></td>
                            <td class="btbg font-center">专票</td>
                            <td class="btbg" colspan="3">
                                <p>营业地址:</p>
                                <p>电话:</p>
                                <p>开户行账号:</p>
                            </td>
                        </tr>
                        <tr>
                            <td class="btbg font-center">金额合计:</td>
                            <td class="btbg" colspan="3"></td>
                            <td class="btbg" colspan="3">备注</td>
                        </tr>
                        <tr>
                            <td class="btbg" colspan="2">收票地址、联系人及电话(快递信息):</td>
                            <td class="btbg" colspan="6"></td>
                        </tr>
                        <tr>
                            <td class="btbg">申请开票日期:</td>
                            <td class="btbg" colspan="7"></td>
                        </tr>
                        <tr>
                            <td class="btbg">合同附件:</td>
                            <td class="btbg" colspan="7"></td>
                        </tr>
                        <tr>
                            <td class="btbg">结算的附件:</td>
                            <td class="btbg" colspan="7"></td>
                        </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="p_employee_list mt15">
                <el-form :rules="formRules" ref="statementForm" :model="formQuery" label-width="90px">
                    <el-form-item label="开票备注:" prop="remark">
                        <el-input v-model="formQuery.remark" type="textarea" rows="4" size="small" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box" v-if="jumpType == 'apply'">
                <el-button type="success">仅保存暂不提交申请</el-button>
                <el-button type="primary">申请重开</el-button>
                <el-button @click="backHandle">取消</el-button>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
import print from 'print-js'
export default {
  name: "updatePost",
  data() {
    return {
        formQuery:{
            type:'',// 归属类型
            Projectid:'',
            departid:'',
            month:'',//归属月
            num:'',//结算单金额
            remark:'',//备注
            checked: false
        },
        formRules:{//规则
            type: [
            { required: true, message: '请选择归属', trigger: 'change' }
            ],
            num: [
            { required: true, message: '请输入法务实体', trigger: 'blur' }
            ]
        },
        projectList:[],//项目列表
        departList:[],//部门列表
        dedpartDiaVal:[],
        stateFileList:[],
        tableLoading:false,
        isEdit:'dtl',
        jumpType:'apply',
        // 详情参数
        dtlQuery:{
            mainuserid:'',
            useridr:''
        },
        props: { label: 'strorganname', value: 'strorgancode', children: 'children', checkStrictly: true },
        tableData:[
            {
                Strtoppowername:'',
                num:''
            }
        ],
        multipleSelection:[],//结算单多选数据
        invoiceData:[]
    }
  },
  created() {
    this.isEdit = this.$route.query.isEdit;
    if(this.$route.query.type){
        this.jumpType = this.$route.query.type;
    }
    this.invoiceData = [
        {
            name:'服务费/管理费',
            num:'',
            piao:'',
            content:'',
            type:'add'
        },
        {
            name:'其他部分',
            num:'',
            piao:'',
            content:'',
            type:'other'
        }
    ]
    // this.getMemberDtl()
  },
  methods: {
    // 新增开票其他部分
    addContentHandle(row){
        let query = {
            name:'',
            num:row.num,
            piao: row.piao,
            content:row.content,
            type:'dtl'
        }
        this.invoiceData.push(query);
    },
    // 删除开票其他部分
    dltContentHandle(index){
        this.invoiceData.splice(index, 1);
    },
    // 新增结算单
    addProHandle(){
        let query = {
            Strmkname:'',
            Strtoppowername:'',
            num:'',
            Strpowername:''
        }
        this.tableData.push(query)
    },
    departChange(val){

    },
    handleExceed() {
      this.$message.warning(`当前限制最多上传 5 个文件`);
    },
    // 删除结算单
    handleFileRemove(){

    },
    // 上传结算单
    success_handle(){

    },
    // 表格多选
    handleSelectionChange(val) {
      // console.log('yyy',val)
      this.multipleSelection = val;
    },
    //打印
    printClick(id, ignoreIds) {
        const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
        setTimeout(function () {
            printJS({
            printable: id, // 标签元素id
            type: 'html',
            targetStyles: ['*'],
            style: `.page{margin:10px;height:2000px};table{border-collapse:separate}`,
            });
        }, 500)
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
    },
    // 取消
    backHandle(){
        this.$router.push({
            path: "/invoicing",
        });
    },
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
    }
  }
}
</script>
<style scoped>
.f_open_foot .o_txt{
    color:#409EFF;
    width: 80px;
    text-align: right;
}
.i_reopen_box{
    flex: 1;
}
.i_reopen_box{
    flex-wrap: wrap;
}
.f_open_foot.f_foot{
    align-items: flex-start;
}
.f_foot_box{
    font-size: 14px;
    color:#555;
}
.flex_box{
    justify-content: space-around;
    flex-wrap: wrap;
}
.f_foot_box,.f_foot{
    align-items: center;
}
.t_sel{
    margin-left: 15px;
}
.f_foot{
    margin-left: 40px;
}
.foot_left_box{
    width: 80px;
}
.f_sel01{
    margin-right: 10px;
}
.f_com_box{
    padding: 20px 5px;
}
.f_icon{
    font-size: 20px;
    color:#19bd92;
}
.f_list_box{
    width: 32%;
    align-items: center;
    font-size: 14px;
    color:#555;
}
.f_left_box{
    width: 100px;
}
.f_right_box{
    flex: 1;
}
.add_box{
    align-items: center;
    margin-top: 15px;
}
.btn01{
    margin-left: 10px;
}
.mt15{
    margin-top: 15px;
}
.pt20{
    padding-top: 20px;
}
.com_style{
    background-color: #E8F7F7;
}
.i_radio_box{
  display: -webkit-box;
  /* align-items: center; */
}
.i_box{
  margin-left: 30px;
}
.print_box{
    justify-content: flex-end;
}
  .centerTitle {
    width: 100%;
    /* margin-bottom: 5px; */
    border: 1px solid #000;
    border-bottom: none;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    box-sizing: border-box;
  }
  .com_form_box{
    margin: 15px 0;
  }
  .tabtop td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }
  .font-center {
    text-align: center
  }
  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
  }
.d_txt{
    font-size: 14px;
    color: #555;
    margin-top: 20px;
}
.btn_box{
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
.line_box{
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
}
.dtl_table{
    box-sizing: border-box;
    margin-top: 15px;
}
.emp_txt{
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.r_edit_title{
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color:#000;
    /* border-bottom: 1px solid #DCDFE6; */
}
.emp_form_txt{
    width: 370px;
    font-size: 14px;
    color: #000;
}
.txts01{
    font-size: 14px;
}
.p_employee_item{
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
}
.p_employee_form.p_employee_form01{
    margin-top: 0;
}
.p_employee_form{
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}
.p_employee_box{
    background-color: #fff;
    padding: 15px 10px;
}
</style>
<style>
.p_reopen_box .i_reopen_box .el-select,
.p_reopen_box .i_reopen_box .el-input{
    width: 300px;
    margin-bottom: 5px;
}
.p_reopen_box .f_reopen_box .el-form-item{
    margin-bottom: 0;
}
.up_invoice_content .f_sel_box .el-select{
    width: 150px;
}
.up_invoice_content .dtl_table .el-table,
.up_invoice_content .dtl_table .el-table th.el-table__cell,
.i_list.el-table tr{
  background-color: #E8F7F7; /* 你想要的背景色 */
}
.form_table td{
    border: #000 1px solid;
}
.e_dtl_content .el-table .el-table__cell{
    padding: 4px 0;
}
</style>